import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { getTranslation, logError } from "../helpers/utils";
import { getInitialData } from "./InitialDataSlice";

export const getAppContent = createAsyncThunk(
  "AppContent/getAppContent",
  async (data, { rejectWithValue, getState }) => {
    try {
      // Skip API call if raw data exists
      const state = getState();
      if (state.appContent.rawAppContent && state.appContent.rawAppContent.length > 0) {
        return { langId: data.selLanguageId, res: state.appContent.rawAppContent, fromCache: true };
      }
      const response = await axios.get(
        `${process.env.REACT_APP_LOCAL_API}/app-content`
      );
      return { langId: data.selLanguageId, res: response.data.data.AppContent };
    } catch (error) {
      logError(error, "AppContent/getAppContent");
      return rejectWithValue(error.response.data);
    }
  }
);

const processAppContent = (state, content, langId) => {
  if (!content) return;
  state.rawAppContent = content; // Store raw for re-translation
  state.appContent = content.map((lang) => {
    let trans = { ...lang };
    trans.title = getTranslation(lang.title, langId);
    return trans;
  });
};

export const AppContent = createSlice({
  name: "appContent",
  initialState: {
    appContent: [],
    rawAppContent: [], // Store raw data for re-translation
    selectedProvider: "",
    selectedProviderEng: "",
    selectedService: "",
  },
  reducers: {
    setSelectedProvider: (state, action) => {
      state.selectedProvider = action.payload;
    },
    setSelectedProviderEng: (state, action) => {
      state.selectedProviderEng = action.payload;
    },
    setSelectedService: (state, action) => {
      state.selectedService = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAppContent.fulfilled, (state, action) => {
        processAppContent(state, action.payload.res, action.payload.langId);
      })
      .addCase(getAppContent.rejected, (state, action) => {
        toast.error(action.payload);
      })
      // Listen for initial data load
      .addCase(getInitialData.fulfilled, (state, action) => {
        if (action.payload?.AppContent) {
          state.rawAppContent = action.payload.AppContent;
          // Don't translate yet - wait for language selection
        }
      });
  },
});
export const {
  setSelectedProvider,
  setSelectedProviderEng,
  setSelectedService,
} = AppContent.actions;

export default AppContent.reducer;
